module.exports = __webpack_public_path__ + "static/media/abattoir-cover-video.9df37c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-cover-video.jpg
// module id = 588
// module chunks = 0